module.exports = __webpack_public_path__ + "img/success-icon.e02cb5df.jpeg";